export default __webpack_public_path__ + "static/media/image2.318a7c12.jpg";